import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TreeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12.87 2.504l4 7A1 1 0 0116 11h-.133l3.011 5.521A1 1 0 0118.001 18h-5v3a1 1 0 01-.883.993l-.117.007a1 1 0 01-1-1v-3h-5a1 1 0 01-.877-1.479L8.134 11h-.133a1 1 0 01-.868-1.496l4-7a1 1 0 011.737 0zM12 5.016L9.725 9h.094a1 1 0 01.878 1.479L7.686 16h8.63l-3.01-5.521A1 1 0 0114.183 9h.095l-2.277-3.984z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
TreeIcon.isCarinaIcon = true;
export default TreeIcon;
